export const getTodoCollectionId = (): string => {
  return `todo`
}

export const getKeepCollectionId = (): string => {
  return `keep`
}

export const getEventCollectionId = (): string => {
  return `event`
}
export const getMemoCollectionId = (): string => {
  return `memo`
}

export const getSuggestionCollectionId = (): string => {
  return `suggestion`
}
